import Config from "config"
import axios from 'axios'
import store from 'store'

export class Credentials {
    constructor(
        public username: string | undefined,
        public password: string | undefined
    ) {}
}

const Auth = {

    clearCredentials: (): void => {
        store.remove('username')
        store.remove('password')
        store.remove('isAdmin')
    },

    setCredentials: (credentials: { username: string | undefined; password: string | undefined }): void => {
        store.set('username', credentials.username)
        store.set('password', credentials.password)
    },

    getCredentials: (): Credentials => {
        return new Credentials(
            store.get('username') as string | undefined,
            store.get('password') as string | undefined
        )
    },

    getIsAdmin: (): boolean => {
        return (store.get('isAdmin') as boolean) ?? false
    },

    validateCredentials: (credentials: { username: string | undefined; password: string | undefined }): Promise<boolean> => {
        return axios({
            method: 'get',
            url: Config.apiHost + "/self",
            auth: {
                username: credentials.username as string,
                password: credentials.password as string,
            },
        }).then(function (response) {
            if (response.status >= 200 && response.status < 300) {
                store.set('isAdmin', response.data?.isAdmin ?? false)
                return true
            } else {
                throw response
            }
        })
    }
}

Object.freeze(Auth)
export { Auth }
